import type { PurchaseDeliveryApi } from "../../api/PurchaseDeliveryApi";
import type { AddressStaff } from "../../generated/dto/AddressStaff";
import type { PersonFetchOptions } from "../../generated/dto/PersonFetchOptions";
import type { PersonStaff } from "../../generated/dto/PersonStaff";
import type { PurchaseDeliveryFetchOptions } from "../../generated/dto/PurchaseDeliveryFetchOptions";
import type { PurchaseDeliveryStaff } from "../../generated/dto/PurchaseDeliveryStaff";

export class PurchaseDeliveryFrontendService {
  constructor(private readonly api: PurchaseDeliveryApi) {}
  async getPurchaseDeliveryStaff(id: number, options?: PurchaseDeliveryFetchOptions): Promise<PurchaseDeliveryStaff> {
    return this.api.getPurchaseDeliveryStaff(id, options)
  }
  async getPurchaseDeliveryStaffTargetPerson(id: number, options?: PersonFetchOptions): Promise<PersonStaff | null> {
    return this.api.getPurchaseDeliveryStaffTargetPerson(id, options)
  }
  async getPurchaseDeliveryStaffTargetAddress(id: number): Promise<AddressStaff | null> {
    return this.api.getPurchaseDeliveryStaffTargetAddress(id)
  }
}
